import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <section className="relative min-h-screen flex items-center pt-24 overflow-hidden" data-id="element-79">
      {/* Background Image & Overlays */}
      <div className="absolute inset-0 z-0" data-id="element-80">
        <img src="https://images.unsplash.com/photo-1618828665011-0abd973f7bb8?w=1920&q=80" alt="Lagos Skyline at Dusk" className="w-full h-full object-cover object-center" data-id="element-81" />
        <div className="absolute inset-0 bg-gradient-to-r from-navy/90 via-navy/70 to-navy/40 mix-blend-multiply" data-id="element-82" />
        <div className="absolute inset-0 bg-navy/30" data-id="element-83" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-84">
        <motion.div className="max-w-3xl text-center md:text-left mx-auto md:mx-0" variants={containerVariants} initial="hidden" animate="visible" data-id="element-85">
          <motion.h1 variants={itemVariants} className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6" data-id="element-86">
            Your Gateway to <br className="hidden md:block" data-id="element-87" />
            <span className="text-gold" data-id="element-88">African Enterprise.</span>
          </motion.h1>

          <motion.p variants={itemVariants} className="font-sans text-lg md:text-xl text-white/90 max-w-2xl mb-10 leading-relaxed mx-auto md:mx-0" data-id="element-89">
            Helping US Companies Navigate Public Policy, Strategic
            Communications, and Impact Evaluation in Nigeria and Ghana.
          </motion.p>

          <motion.div variants={itemVariants} data-id="element-90">
            <button className="bg-gold hover:bg-gold-light text-navy font-sans font-bold text-base uppercase tracking-wide px-8 py-4 rounded-card transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-91">
              Explore Our Practice
            </button>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}